// components/TrustBadges/badgesPart2.tsx — last 4 badge definitions
import type { BadgeItem, TrustBadgesProps } from './types';

export const buildBadgesPart2 = (badges: TrustBadgesProps['settings']['badges']): BadgeItem[] => [
    {
        key: 'freeShipping',
        enabled: badges.freeShipping,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
            </svg>
        ),
        text: 'Gratis Ongkir',
        color: 'text-indigo-600 dark:text-indigo-400'
    },
    {
        key: 'fastShipping',
        enabled: badges.fastShipping,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
        ),
        text: 'Pengiriman Cepat',
        color: 'text-amber-600 dark:text-amber-400'
    },
    {
        key: 'verifiedSeller',
        enabled: badges.verifiedSeller,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
            </svg>
        ),
        text: 'Penjual Terpercaya',
        color: 'text-emerald-600 dark:text-emerald-400'
    },
    {
        key: 'ssl',
        enabled: badges.ssl,
        icon: (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
        ),
        text: 'SSL Secure',
        color: 'text-slate-600 dark:text-slate-400'
    }
];
